import { Pipe, PipeTransform } from '@angular/core';
import { parse } from 'marked';
import dompurify from 'dompurify';

@Pipe({
  standalone: true,
  name: 'markdownParser',
})
export class MarkdownParserPipe implements PipeTransform {
  transform(value: string): string {
    return dompurify.sanitize(parse(value));
  }
}
